var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.63 533.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".microsoft_svg__d{fill:#00adef}.microsoft_svg__e{fill:#f1511b}.microsoft_svg__f{fill:#fbbc09}.microsoft_svg__g{fill:#80cc28}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft_svg__a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "microsoft_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__e",
    d: "M253.61,253.61H0V0H253.61V253.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__g",
    d: "M533.63,253.61h-253.61V0h253.61V253.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__d",
    d: "M253.6,533.73H0v-253.61H253.6v253.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__f",
    d: "M533.63,533.73h-253.61v-253.61h253.61v253.61h0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.a87891f6316f633abbf4641ccd88dea9.svg";
export { ForwardRef as ReactComponent };